module.exports = __webpack_public_path__ + "static/media/corporate.bbd74472.jpg";